import { render, staticRenderFns } from "./MultiUpload.vue?vue&type=template&id=796ec252&scoped=true"
import script from "./MultiUpload.vue?vue&type=script&lang=js"
export * from "./MultiUpload.vue?vue&type=script&lang=js"
import style0 from "./MultiUpload.vue?vue&type=style&index=0&id=796ec252&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "796ec252",
  null
  
)

export default component.exports